module.exports = __webpack_public_path__ + "img/CustomAnalytic_64x64.b0e3ef36.png";